<app-shared-dialog [options]="{
  confirmText: 'agent.actions.add_companies' | translate,
  confirmIcon: 'plus-cc',
  confirmIconPosition: 'start',
  cancelText: 'common.cancel' | translate,
  size: 'large'
}" (confirm)="save()"
  (cancel)="cancel()">
  <div class="dialog-header">
    {{ this.data.type === 'client' ? ('Catalogs.new_catalog.audience.add_companies_title' | translate) : ('agent.portfolio.add_companies_title' | translate) }}
  </div>
  <app-agent-companies-list
    [subsidiaryId]="subsidiaryId"
    [initialLocations]="initialSelectedLocations"
    [source]="data.type === 'client' ? 'catalogs' : 'agents'"
    (selectedLocationsChange)="selectedLocationsChange($event)"
    (companiesSelected)="companiesSelected($event)"
  ></app-agent-companies-list>
</app-shared-dialog>